import type { PasswordCheckResult } from "../../shared/api-types";
import { useT } from "../i18n";
import { passwordErrorText } from "../i18n/errors";

const BAR_COLORS = [
  "bg-red-500",
  "bg-orange-500",
  "bg-yellow-500",
  "bg-emerald-500",
  "bg-emerald-600",
];

/**
 * Stärke-Anzeige unter einem Passwortfeld: fünf Segmente (zxcvbn-Score 0–4)
 * plus Text. Zeigt die Ablehnung der Live-Prüfung (usePasswordCheck in der
 * Seite), solange das Passwort so nicht gespeichert würde. Die Seite sperrt
 * dann den Speichern-Button — so steht die Meldung nur einmal da.
 */
export function PasswordStrength({
  password,
  result,
}: {
  password: string;
  result: PasswordCheckResult | null;
}) {
  const t = useT();
  if (!password) return null;
  const filled = result ? result.score + 1 : 0;
  const text = result
    ? (passwordErrorText(t, result.rejection) ?? t.password.strength(result.score))
    : "";
  return (
    <div className="space-y-1" aria-live="polite">
      <div className="flex gap-1">
        {[0, 1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className={`h-1 flex-1 rounded ${
              result && i < filled ? BAR_COLORS[result.score] : "bg-zinc-200 dark:bg-zinc-700"
            }`}
          />
        ))}
      </div>
      <p
        className={`min-h-4 text-xs ${
          result?.rejection ? "text-red-600 dark:text-red-400" : "text-zinc-500 dark:text-zinc-400"
        }`}
      >
        {text}
      </p>
    </div>
  );
}
